export default __webpack_public_path__ + "static/OYOY-800x162-60fps-8b48ca69593390a79188ea485bcbb2f0.mp4";